<p>favorite-table works!</p>
